export const PUBLIC_ROUTES = [
  "/",
  "/login",
  "/signup",
  "/login/offer",
  "/survey",
  "/complete-email-setup",
  "/privacy-policy",
  "/meta",
];

export const RESPONSIVE_ROUTES = [
  ...PUBLIC_ROUTES,
  "/chatbot",
  "/finance",
  "/plans",
  "/settings",
  "/integrations",
  "/membership",
  "/user/preferences",
  "/payment-subscription/cancel",
  "/payment-subscription/success",
  "/payment/:status",
];

export const SKIP_ROUTES = ["/settings", "/user/preferences", "/survey", "/complete-email-setup", "/support-builder"];

export const IMMERSIVE_ROUTES = ["/chatbot", "/finance"];
